import { findLesson } from "./_helpers";
import { LessonShell } from "@/components/LessonShell";
import { RomanNumeralAnalysis } from "@/components/song/RomanNumeralAnalysis";
import { YouTubeEmbed } from "@/components/song/YouTubeEmbed";
import { NoteImage } from "@/components/mt/NoteImage";
import { KeyIdea, Compare } from "@/components/Callouts";
import { Section } from "@/components/Section";

export default function EdSheeran12() {
  const { lesson, course, accent } = findLesson("ed-sheeran", "12");
  return (
    <LessonShell
      course={course}
      courseSlug="ed-sheeran"
      lessonOrder={lesson.order}
      title={lesson.title}
      description={lesson.desc}
      videoUrl={lesson.video}
      thumbUrl={lesson.thumb}
      accent={accent}
    >
      <Section eyebrow="Lesson 12" title="For Always">
        <YouTubeEmbed videoId="NtmnOkoKcRo" title="For Always — Ed Sheeran" />
        <NoteImage
          src="/notes/ed-sheeran/finals/12-for-always.png"
          caption="Jason's handwritten chord chart for this lesson."
        />
      </Section>

      <Section eyebrow="Chord analysis" title="B major — a bar of 3/4, then a bar of 4/4">
        {/* Jason's chart: (3/4) B B/D# B | (4/4) E  x3; 4th time (3/4) G#m F# B | (4/4) E */}
        <RomanNumeralAnalysis
          label="Opening phrase — 3/4 then 4/4"
          caption="One bar of 3/4 (B, B/D#, B — one chord per beat), then one bar of 4/4 held on E. Played three times."
          chords={[
            { chord: "B",    rn: "I",  function: "Tonic",        pitches: ["B2","D#3","F#3","B3"] },
            { chord: "B/D#", rn: "I⁶", function: "Tonic",        pitches: ["D#3","F#3","B3","D#4"] },
            { chord: "B",    rn: "I",  function: "Tonic",        pitches: ["B2","D#3","F#3","B3"] },
            { bar: true },
            { chord: "E",    rn: "IV", function: "Pre-dominant", pitches: ["E3","G#3","B3","E4"] },
          ]}
        />
        <RomanNumeralAnalysis
          label="Fourth time"
          caption="The 3/4 bar changes to G#m → F# → B before landing on E again."
          chords={[
            { chord: "G#m", rn: "vi", function: "Submediant",   pitches: ["G#2","B2","D#3","G#3"] },
            { chord: "F#",  rn: "V",  function: "Dominant",     pitches: ["F#2","A#2","C#3","F#3"] },
            { chord: "B",   rn: "I",  function: "Tonic",        pitches: ["B2","D#3","F#3","B3"] },
            { bar: true },
            { chord: "E",   rn: "IV", function: "Pre-dominant", pitches: ["E3","G#3","B3","E4"] },
          ]}
        />
        <KeyIdea title="Changing meter">
          The beat does not change speed — the bar length does. A bar of three beats is followed
          by a bar of four, so each pair is seven beats long. This is called changing (or mixed)
          meter. After this phrase, the rest of Jason's chart is in 4/4.
        </KeyIdea>
      </Section>
      <Section eyebrow="Takeaway" title="Three beats, then four">
        <Compare
          leftLabel="3/4 bar"
          left="Three beats, one chord on each: B, B/D♯, B."
          rightLabel="4/4 bar"
          right="Four beats held on a single E chord."
        />
      </Section>
    </LessonShell>
  );
}
